import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';
import translationES from './locales/es.json';

// the translations
const resources = {
  en: {
    translations: translationEN,
  },
  fr: {
    translations: translationFR,
  },
  es: {
    translations: translationES,
  },
};

const spectreLanguageDetector = {
  name: 'spectre_language',

  lookup: function lookup() {
    let _language;
    let _country;
    if (typeof window !== 'undefined') {
      _language = window.localStorage.getItem('spectre_language');
      _country = window.localStorage.getItem('spectre_country');

      if (!_language) {
        _language = navigator.language.split('-')[0];
      }

      if (!_country) {
        _country =
          navigator.language.split('-').length > 1
            ? navigator.language.split('-')[1]
            : 'CA';
      }

      window.localStorage.setItem('spectre_country', _country);
    }

    return _language;
  },
  cacheUserLanguage: function cacheUserLanguage(lng) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('spectre_language', lng);
    }
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(spectreLanguageDetector);

const languageDetectionOptions = {
  // order and from where user language should be detected
  order: ['spectre_language'],

  // cache user language on
  caches: ['spectre_language'],
};

i18n
  .use(languageDetector)
  .use(reactI18nextModule)
  .init({
    resources,
    detection: languageDetectionOptions,
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
    },
  });

export default i18n;
